import { gql } from '@apollo/client'

export const CHATBOT_SETTINGS_FIELDS = gql`
  fragment ChatbotSettingsFields on ChatbotSettings {
    id
    appNotificationsEnabled
    communicationStyle
    dataSharingEnabled
    emailNotificationsEnabled
  }
`
